import React from 'react';
import './styles.css';

interface IconProps {
  className?: string;
  onClick?: () => void;
}

export const UpIcon: React.FC<IconProps> = ({ className, onClick }) => {
  return (
    <span className={`custom-icon ${className || ''}`} onClick={onClick}>
      <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
        <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" />
      </svg>
    </span>
  );
};

export const DownIcon: React.FC<IconProps> = ({ className, onClick }) => {
  return (
    <span className={`custom-icon ${className || ''}`} onClick={onClick}>
      <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
        <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" />
      </svg>
    </span>
  );
};

export const SwapIcon: React.FC<IconProps> = ({ className, onClick }) => {
  return (
    <span className={`custom-icon ${className || ''}`} onClick={onClick}>
      <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
        <path d="M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-0.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2 0.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" />
      </svg>
    </span>
  );
};

export default {
  UpIcon,
  DownIcon,
  SwapIcon
};
